import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/app/background-jobs")({
  component: Outlet,
  beforeLoad: (context) => ({
    getTitle: () =>
      context.context.t && context.context.t("AutomaticBackgroundJobs"),
  }),
})
